import $ from 'jquery';
import slick from 'slick-carousel';


export default (selector) => {
    if ($(selector).length > 0) {

        $(selector)

            .slick({
                autoplay: false,
                dots: false,
                arrows: false,
                adaptiveHeight: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            })
            .on("afterChange", function (e, slick) {

                var currentIndex = $('.slick-current').attr('data-slick-index');

                if (currentIndex == 0) {
                    $(".previous_caro").removeClass("opacity-1");
                }
                else {
                    $(".previous_caro").addClass("opacity-1");
                }

                var offset = $(selector).find('.slick-active').length;

                if (currentIndex == $(".slick-slide").length - offset) {
                    $(".next_caro").removeClass("opacity-1");
                }
                else {
                    $(".next_caro").addClass("opacity-1");
                }

            })


        $('.previous_caro').click(function () {
            $(selector).slick('slickPrev');
        });

        $('.next_caro').click(function () {
            $(selector).slick('slickNext');
        });
        
        var currentIndex = $('.slick-current').attr('data-slick-index');
        var offset = $(selector).find('.slick-active').length;

        if (currentIndex == $(".slick-slide").length - offset) {
            $(".next_caro").removeClass("opacity-1");
        }
        else {
            $(".next_caro").addClass("opacity-1");
        }



    }
};



// WEBPACK FOOTER //
// ./scripts/libs/sliderPremi.js